/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Min_RequiredInputs */

const en_password_min_required = /** @type {(inputs: Password_Min_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 1 character required`)
};

const nl_password_min_required = /** @type {(inputs: Password_Min_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaal 1 teken vereist`)
};

/**
* | output |
* | --- |
* | "At least 1 character required" |
*
* @param {Password_Min_RequiredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const password_min_required = /** @type {((inputs?: Password_Min_RequiredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Min_RequiredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_password_min_required(inputs)
	return en_password_min_required(inputs)
});